import { render, staticRenderFns } from "./MerchantAccountSettings.vue?vue&type=template&id=634c3e68"
import script from "./MerchantAccountSettings.vue?vue&type=script&lang=js"
export * from "./MerchantAccountSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports